(function (global, factory) {
    factory(require('jquery'))
}(this, (function ($) { 'use strict';

    global.CollapsibleList = {
        events: function() {
            $(window).resize(CollapsibleList.lists.asyncCollapse);
        },
        lists: {
            asyncCollapse: async function() {
                await CollapsibleList.lists.collapse();
            },
            collapse: function() {
                // Hide children
                $('.collapsible-list').children().addClass('d-none');

                $('.collapsible-list').each(function(index, element) {
                    // Get parent width
                    let parentWidth = $(element).innerWidth();
                    let childrenWidth = 60; // Add the hidden items counter width + margin
                    let hiddenChildren = 0;
                    let id = $(element).data('id');

                    $(element).children().not('.cl-hidden').each(function(childIndex, child) {
                        // Get hidden element width
                        $(child).css({ position: "absolute", visibility: "hidden" });
                        $(child).removeClass('d-none');

                        // Add width to total
                        childrenWidth += $(child).outerWidth() + 10; // 10 is the margin

                        // Check if the new element would break the container
                        if (childrenWidth > parentWidth) {
                            $(child).addClass('d-none');
                            hiddenChildren++;
                        }

                        // Reset properties
                        $(child).css({ position: "", visibility: "" });
                    });

                    // Add hidden children total
                    if (hiddenChildren) {
                        // Check if the div exists
                        if ($(element).find('.cl-hidden').length) {
                            $(element).find('.cl-hidden').html("+" + hiddenChildren).removeClass('d-none');
                        } else {
                            $('<div class="cl-hidden" data-bs-toggle="modal" data-bs-target="#modal-services-' + id + '">' +
                                '+' + hiddenChildren + '</div>').appendTo(element);
                        }
                    }
                });
            }
        },
        init: function() {
            // Hide all children
            $('.collapsible-list').children().addClass('d-none');

            CollapsibleList.events();

            $(function() { $(window).resize(); });
        },
    };

})));
